import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { AppConfigContext } from '@infl-ts/util-app-config';
import { useToggle } from '@infl-ts/util-hooks';
import { usePageEventsTracker } from '@infl-ts/util-page-events-tracker';
import { Button } from '@mui/material';
import * as E from 'fp-ts/Either';
import { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';
import { ENTERED, ENTERING, EXITED, EXITING } from 'react-transition-group/Transition';
import { challengePages, onboardingCategories, statusUpdateFailure, updateOnboardingStatus } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultStyle = {
  position: 'relative',
  transition: "top 400ms ease-in-out, opacity 400ms",
  opacity: 0,
  top: 50
};

var transitionStyles = function transitionStyles(state) {
  switch (state) {
    case ENTERING:
    case ENTERED:
      return {
        opacity: 1,
        top: 0
      };

    case EXITING:
    case EXITED:
      return {
        opacity: 0,
        top: 50
      };

    default:
      return {};
  }
};

var EnterButtonAnimation = function EnterButtonAnimation(_ref) {
  var isAnimated = _ref.isAnimated,
      _children = _ref.children;
  return /*#__PURE__*/_jsx(Transition, {
    "in": isAnimated,
    timeout: 400,
    "data-element": "Transition",
    "data-component": "EnterButtonAnimation",
    "data-source-file": "enter-hub-button.tsx",
    children: function children(state) {
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, defaultStyle), transitionStyles(state)),
        children: _children
      });
    }
  });
};

export var EnterHubButton = function EnterHubButton(_ref2) {
  var closeChallengePlayer = _ref2.closeChallengePlayer;

  var _usePageEventsTracker = usePageEventsTracker(),
      trackClick = _usePageEventsTracker.trackClick;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isAnimated = _useToggle2[0],
      startAnimation = _useToggle2[1].on;

  var _useContext = useContext(AppConfigContext),
      programName = _useContext.programName;

  var _useContext2 = useContext(AppAlertsContext),
      showAlert = _useContext2.showAlert;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _updateOnboardingStat = updateOnboardingStatus({
    onCompleted: E.match(function () {
      return showAlert(statusUpdateFailure(t));
    }, function (_ref3) {
      var updateOnboardingStatus = _ref3.updateOnboardingStatus;
      if (updateOnboardingStatus.__typename === 'UpdateOnboardingStatusSuccess') trackClick('Enter Hub', onboardingCategories.challenge, challengePages.completion);else showAlert(statusUpdateFailure(t));
    })
  }),
      _updateOnboardingStat2 = _slicedToArray(_updateOnboardingStat, 1),
      updateStatus = _updateOnboardingStat2[0];

  var completeOnboarding = useCallback(function () {
    return void updateStatus({
      variables: {
        input: {
          status: 'PASSED'
        }
      }
    });
  }, [updateStatus]);
  useEffect(startAnimation, []);
  return /*#__PURE__*/_jsx(EnterButtonAnimation, {
    isAnimated: isAnimated,
    "data-element": "EnterButtonAnimation",
    "data-component": "EnterHubButton",
    "data-source-file": "enter-hub-button.tsx",
    children: /*#__PURE__*/_jsx(Button, {
      variant: "contained",
      onClick: function onClick() {
        completeOnboarding();
        closeChallengePlayer();
      },
      "data-element": "Button",
      "data-component": "EnterHubButton",
      "data-source-file": "enter-hub-button.tsx",
      children: t('Enter {{programName}}', {
        programName: programName
      })
    })
  });
};